import { atom } from 'jotai'
import { IntegrationServices } from '@sequencehq/api'
import { DEFAULT_QUANTITY, DEFAULT_RATE_DISPLAY } from '../../constants'
import { createFieldAtom } from '../../common/atoms'
import { RateDisplay } from 'Invoices/types'

export type FormState = {
  title: string
  quantity: string
  rate: string
  rateDisplay: RateDisplay
  descriptionEnabled: boolean
  description: string
  externalIds: Array<{ key: IntegrationServices; value: string }>
}

export const INITIAL_STATE: FormState = {
  title: '',
  quantity: DEFAULT_QUANTITY,
  rate: '',
  rateDisplay: DEFAULT_RATE_DISPLAY,
  descriptionEnabled: false,
  description: '',
  externalIds: []
}

export const formStateAtom = atom<FormState>(INITIAL_STATE)

export const titleAtom = createFieldAtom(formStateAtom, 'title')
export const quantityAtom = createFieldAtom(formStateAtom, 'quantity')
export const rateAtom = createFieldAtom(formStateAtom, 'rate')
export const rateDisplayAtom = createFieldAtom(formStateAtom, 'rateDisplay')
export const descriptionEnabledAtom = createFieldAtom(
  formStateAtom,
  'descriptionEnabled'
)
export const descriptionAtom = createFieldAtom(formStateAtom, 'description')
export const externalIdsAtom = createFieldAtom(formStateAtom, 'externalIds')
